export const isValidJsonString = (value: string) => {
  if (typeof value !== 'string') {
    return false;
  }

  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
};

export const parse = (value: string | object) => {
  if (typeof value === 'object') {
    return value;
  }
  if (typeof value !== 'string') {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};
